import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const stats = [
  { value: '100K+', label: 'Tracks' },
  { value: '<10ms', label: 'Search' },
  { value: '6', label: 'Formats' },
  { value: '4', label: 'Sources' },
];

export default function Stats() {
  const ref = useRef(null);
  const v = useInView(ref, { once: true, margin: '-40px' });

  return (
    <section data-testid="stats-section" ref={ref} style={{ padding: '0', borderTop: '1px solid rgba(255,255,255,0.04)', borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
      <div className="container" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)' }} className2="stats-g">
        {stats.map((s, i) => (
          <motion.div key={i} data-testid={`stat-${i}`} initial={{ opacity: 0 }} animate={v ? { opacity: 1 } : {}} transition={{ duration: 0.6, delay: i * 0.08 }}
            style={{ padding: '40px 0', textAlign: 'center', borderRight: i < 3 ? '1px solid rgba(255,255,255,0.04)' : 'none' }}>
            <div style={{ fontFamily: 'var(--heading)', fontWeight: 800, fontSize: 'clamp(1.8rem,3vw,2.5rem)', color: '#FAFAFA', letterSpacing: '-0.03em', marginBottom: 4 }}>{s.value}</div>
            <div style={{ fontFamily: 'var(--mono)', fontSize: 11, color: '#52525B', fontWeight: 500, letterSpacing: '0.08em', textTransform: 'uppercase' }}>{s.label}</div>
          </motion.div>
        ))}
      </div>
      <style>{`@media(max-width:600px){.container{grid-template-columns:repeat(2,1fr) !important}}`}</style>
    </section>
  );
}
